import { render } from "./PlatecameraModal.vue?vue&type=template&id=4c0ad3ec"
import script from "./PlatecameraModal.vue?vue&type=script&lang=js"
export * from "./PlatecameraModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__